import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { StudentDashboard } from './dashboards/StudentDashboard';
import { TutorDashboard } from './dashboards/TutorDashboard';
import { OrganizationDashboard } from './dashboards/OrganizationDashboard';

export const Dashboard = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600">Loading dashboard...</p>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  // Render dashboard based on user role
  switch (user.role) {
    case 'student':
      return <StudentDashboard />;
    case 'tutor':
      return <TutorDashboard />;
    case 'organization':
      return <OrganizationDashboard />;
    case 'admin':
      navigate('/admin');
      return null;
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <p className="text-gray-600">Unknown user role</p>
        </div>
      );
  }
};
